export class CottageInformation {
    constructor(public image: string, public text: string) {}
}